"use strict";
document.addEventListener("click", function(e) {
    var clamp = function clamp(val, min, max) {
        return Math.max(min, Math.min(val, max));
    };
    var wall = e.target.closest(".wall");
    if (!wall) return;
    var spider = wall.children[0];
    var rect = wall.getBoundingClientRect();
    var style = getComputedStyle(wall);
    var border = parseFloat(style.borderLeftWidth);
    var posX = e.clientX - rect.left - border;
    var posY = e.clientY - rect.top - border;
    var x = posX - spider.offsetWidth / 2;
    var y = posY - spider.offsetHeight / 2;
    var maxX = wall.clientWidth - spider.offsetWidth;
    var maxY = wall.clientHeight - spider.offsetHeight;
    spider.style.left = clamp(x, 0, maxX) + "px";
    spider.style.top = clamp(y, 0, maxY) + "px";
});

//# sourceMappingURL=index.b9753bbe.js.map
